import { AuthError } from './auth-error';

export class SessionExpiredError extends AuthError {
  
}